import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getRequest } from "../services/apiMethods";

export default function ThankYouPage() {
  const Navigate = useNavigate();
  const userId = sessionStorage.getItem("userId");
  const upgrade = sessionStorage.getItem("upgrade") === "true";

  const { data: getUserDetail, isLoading: loading } = useQuery({
    queryKey: ["getuserDetail", userId],
    queryFn: () => getRequest(`user/detail/${userId}`),
    enabled: Boolean(userId),
    onSuccess: (data) => { },
  });

  useEffect(() => {
    setTimeout(() => {
      Navigate(`/thank-you`);
    }, 2000);
  }, []);

  return (
    <>
      <section className="commn-bg-set">
        <div className="card-center-set">
          <div className="commn-card-theme">
            <img
              className="side-logo-set"
              src={require("../Assets/images/logo-main.png")}
            />
            <h2>Thank You</h2>
            <p className="m-0">We can’t wait to see you</p>
            <div className="shop-detail-view pt-2">
              <h3>Your Details</h3>
              <p className="m-1">
                {getUserDetail?.result?.firstName}{" "}
                {getUserDetail?.result?.surname}
                <br />
                {getUserDetail?.result?.email}
              </p>
              {/* <h3 className="mt-4">Your Chosen Store</h3>
              <p>
                {getUserDetail?.result?.preferedStoreId?.name}
                <br />
                {getUserDetail?.result?.preferedStoreId?.address?.firstLine}
                <br />
                {getUserDetail?.result?.preferedStoreId?.address?.secondLine}
                <br />
                {getUserDetail?.result?.preferedStoreId?.address?.townORcity}
                <br />
                {getUserDetail?.result?.preferedStoreId?.address?.postcode}
              </p> */}
              <h3 className="mt-4">Your Subscription</h3>
              <p>
                {getUserDetail?.result?.subscriptionId?.title} Membership
                <br />£{getUserDetail?.result?.subscriptionId?.price} per month
                {/* <br />
                Includes 1 coﬀee per day at any Quaﬀee */}
                <br />
                {getUserDetail?.result?.subscriptionId?.description}
              </p>
              <div className="mt-4">
                <button
                  onClick={() => {
                    if (upgrade) {
                      // User upgraded → return to app
                      window.location.href = "quaffee://";
                      // Only clear if deep link works (page will unload)
                      setTimeout(() => {
                        sessionStorage.removeItem("upgrade");
                        sessionStorage.clear();
                        localStorage.clear();
                      }, 1000);
                    } else {
                      sessionStorage.removeItem("upgrade");
                      sessionStorage.clear();
                      localStorage.clear();
                      const ua = navigator.userAgent || "";
                      const platform = navigator.platform || "";
                      const maxTouchPoints = navigator.maxTouchPoints || 0;

                      // Check Android: user agent match or userAgentData if available
                      let isAndroid = /android/i.test(ua);
                      if (!isAndroid && navigator.userAgentData) {
                        isAndroid = /android/i.test(navigator.userAgentData.platform || "");
                      }

                      // Check iOS: user agent match or iPad OS check
                      let isIOS = /iPad|iPhone|iPod/i.test(ua) ||
                        (platform === "MacIntel" && maxTouchPoints > 1);
                      if (!isIOS && navigator.userAgentData) {
                        isIOS = /ios/i.test(navigator.userAgentData.platform || "");
                      }

                      const playStoreUrl = process.env.REACT_APP_PLAY_STORE_URL;
                      const appStoreUrl = process.env.REACT_APP_APP_STORE_URL;
                      const customerUrl = process.env.REACT_APP_QUAFFEE_CUSTOMER_URL;

                      console.log("Redirection Debug Info:", {
                        ua,
                        platform,
                        maxTouchPoints,
                        isAndroid,
                        isIOS,
                        playStoreUrl,
                        appStoreUrl,
                        customerUrl
                      });

                      if (isAndroid) {
                        window.location.href = playStoreUrl;
                      } else if (isIOS) {
                        window.location.href = appStoreUrl;
                      } else {
                        window.location.href = customerUrl;
                      }
                    }
                  }}
                >
                  {upgrade ? "Return to App" : "Download the App"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
